import { createJSONStorage } from "zustand/middleware";

const getDomainNameWithoutSubdomain = (): string => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  if (parts.length > 2) {
    return parts.slice(1).join("."); // Remove subdomain
  }

  return hostname; // No subdomain, return as is
};

/**
 * How long the browser keeps the auth cookie: 30 days, the longest a refresh token lives. Without it
 * the cookie ended with the browser session, and with it the sign-in. Every write (each token
 * refresh included) starts the 30 days again; a cookie outliving its refresh token only costs a
 * sign-in, when the refresh is refused.
 */
export const AUTH_COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

export const createCookieStorage = <T>(localStorageSyncKey?: string) =>
  createJSONStorage<T>(() => {
    const cookies = document.cookie.split("; ").reduce(
      (acc, cookie) => {
        const [key, value] = cookie.split("=");
        acc[key] = decodeURIComponent(value);

        return acc;
      },
      {} as Record<string, string>,
    );

  return {
    getItem: (name: string) => cookies[name] || null,
    setItem: (name: string, value: string) => {
      const domain = getDomainNameWithoutSubdomain();
      const isCurrentSchmeHttps = window.location.protocol === "https:";
      document.cookie = `${name}=${encodeURIComponent(
        value,
      )}; path=/; domain=${domain}; max-age=${AUTH_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax; ${isCurrentSchmeHttps ? 'Secure' : ''}`
      if (localStorageSyncKey) {
        localStorage.setItem(localStorageSyncKey, Date.now().toString());
      }
    },
    removeItem: (name: string) => {
      // Same domain as setItem, or the browser deletes a different (host-only) cookie
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${getDomainNameWithoutSubdomain()};`;
    },
  };
});
